import {articleTestIds} from '@shared/Articles/ArticleTestIds';

import {ImageWithFormats} from '@strapi/types/global';

import styles from './ArticleHeroImage.module.scss';

type Props = {
  image: ImageWithFormats;
  alt?: string;
};

export const ArticleHeroImage = ({image, alt}: Props) => {
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      className={styles.image}
      src={image.url}
      alt={alt || image.alternativeText || image.name}
      loading="lazy"
      data-testid={articleTestIds.proStoreArticlePageImage}
    />
  );
};
